export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./multiselect.vue?vue&type=template&id=20f1d5eb"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/multiselect.vue?vue&type=template&id=20f1d5eb
// module id = xXOq
// module chunks = 0